// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgLevelLow = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <rect
      width={5}
      height={6.667}
      x={1.667}
      y={11.668}
      fill="currentColor"
      rx={1}
    />
    <rect
      width={4}
      height={10.667}
      x={8}
      y={7.168}
      stroke="currentColor"
      rx={0.5}
    />
    <rect
      width={4}
      height={15.667}
      x={13.833}
      y={2.168}
      stroke="currentColor"
      rx={0.5}
    />
  </svg>
);
export const LevelLowIcon = forwardRef(SvgLevelLow);
